import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import * as action from '../actions/task';
import { get, post, del, axiosPut } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';
import {
  startLoading,
  stopLoading
} from '../actions/settings/loading';

export function* getTaskList({ payload }) {
  try {
    const response = yield call(
      get,
      `/task/list?plantId=${payload.plantId}&dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}`
    );
    yield put(action.getTaskListSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getTaskListFail());
  }
}

export function* getSemiListByTask({ payload }) {
  try {
    const response = yield call(
      get,
      `/task/semi_product/list?taskNumId=${payload.taskNumId}`
    );
    yield put(action.getSemiListByTaskSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getSemiListByTaskFail());
  }
}

export function* saveTask({ payload }) {
  try {
    const response = yield call(post, '/task/save', payload);
    yield put(action.saveTaskSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.saveTaskFail());
  }
}

export function* addTaskZdvlLine({ payload }) {
  try {
    yield call(
      post,
      `/task/zdvl_line/add?taskNumId=${
        payload.taskNumId
      }&${payload.zdvlLineIds.map((el) => `zdvlLineIds=${el}&`).join('')}`
    );
    yield put(action.addTaskZdvlLineSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.addTaskZdvlLineFail());
  }
}

export function* addTaskSemi({ payload }) {
  try {
    yield call(
      post,
      `/task/semi_product/add?taskNumId=${
        payload.taskNumId
      }&${payload.semiProductIds.map((el) => `semiProductIds=${el}`).join('&')}`
    );
    yield put(action.addTaskSemiSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.addTaskSemiFail());
  }
}

export function* deleteTaskZdvlLine({ payload }) {
  try {
    yield call(
      del,
      `/task/zdvl_line/delete?taskNumId=${
        payload.taskNumId
      }&${payload.zdvlLineIds.map((el) => `zdvlLineIds=${el}`).join('&')}`
    );
    yield put(action.deleteTaskZdvlLineSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.deleteTaskZdvlLineFail());
  }
}

export function* deleteTaskSemi({ payload }) {
  try {
    yield call(
      del,
      `/task/semi_product/delete?taskNumId=${
        payload.taskNumId
      }&${payload.semiProductIds.map((el) => `semiProductIds=${el}`).join('&')}`
    );
    yield put(action.deleteTaskSemiSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.deleteTaskSemiFail());
  }
}

export function* getZdvlListForAdd({ payload }) {
  try {
    const response = yield call(
      get,
      `/grid/data/zdvl/find/by_task?plantId=${payload.plantId}&taskNumId=${payload.taskNumId}`
    );
    yield put(action.getZdvlListForAddSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getZdvlListForAddFail());
  }
}

export function* deleteTask({ payload }) {
  try {
    yield call(del, `/task/delete?taskNumId=${payload.taskNumId}`);
    yield put(action.deleteTaskSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.deleteTaskFail());
  }
}

export function* updateTask({ payload }) {
  try {
    yield call(
      axiosPut,
      '/task/update',
      {
        taskNumId: payload.taskNumId,
        taskNumber: payload.taskNumber,
        taskDate: payload.taskDate
      }
    );
    yield call(
      notify,
      {
        message: 'Задача успешно обновлена',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(
      get,
      `/task/list?plantId=${payload.plantId}&dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}`
    );
    yield put(action.getTaskListSuccess(response));
    yield put(action.updateTaskSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.updateTaskFail());
  }
}

export function* setOpenCloseTask({ payload }) {
  try {
    yield put(startLoading());
    yield call(axiosPut, `/task/open_or_close?taskNumIds=${payload.taskNumId}`);
    const response = yield call(
      get,
      `/task/list?plantId=${payload.plantId}&dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}`
    );
    yield put(action.getTaskListSuccess(response));
    yield put(action.setOpenCloseTaskSuccess());
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.setOpenCloseTaskFail());
  }
}
